import React, { useEffect, useRef, useState } from 'react'
import { useMutation } from '@apollo/client'
import { Form, FormInstance } from 'antd'
import { UPDATE_LEGAL_FORMALITY_PARAMS_MUTATION } from 'graphql/LegalFormalities'
import { Section, Toggle, SaveBtn } from './components'
import { Field } from './styles'

export type OrderParamsValues = {
  partnerId: string
  partnerCapitalDeposit: string
  taxOption: string
  paidByPartner: string
}

export const ORDER_PARAMS_EMPTY: OrderParamsValues = {
  partnerId: '',
  partnerCapitalDeposit: '',
  taxOption: '',
  paidByPartner: '',
}

type Props = {
  initialValues: OrderParamsValues
  legalFormalityId: number
  indyPartners: { id: string; name: string }[]
  onSaved: () => void
}

const OrderParamsSection = ({
  initialValues,
  legalFormalityId,
  indyPartners,
  onSaved,
}: Props) => {
  const [form] = Form.useForm<OrderParamsValues>()
  const formRef = useRef() as React.MutableRefObject<
    FormInstance<OrderParamsValues>
  >
  const [saved, setSaved] = useState(false)
  const [updateParams, { loading }] = useMutation(
    UPDATE_LEGAL_FORMALITY_PARAMS_MUTATION
  )

  useEffect(() => {
    form.setFieldsValue(initialValues)
  }, [form, JSON.stringify(initialValues)])

  const handleFinish = (values: OrderParamsValues) => {
    updateParams({
      variables: {
        id: legalFormalityId,
        partnerId: values.partnerId || '',
        partnerCapitalDeposit: values.partnerCapitalDeposit || '',
        taxOption: values.taxOption || '',
        paidByPartner: values.paidByPartner || '',
      },
    }).then(() => {
      setSaved(true)
      setTimeout(() => setSaved(false), 2000)
      onSaved()
    })
  }

  return (
    <Section title="Paramètres de commande" defaultOpen>
      <Form
        form={form}
        ref={formRef}
        onFinish={handleFinish}
        layout="vertical"
        style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
      >
        <Field>
          <label>Partner</label>
          <Form.Item name="partnerId" noStyle>
            <select>
              <option value="">— aucun —</option>
              {indyPartners.map(p => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>
          </Form.Item>
        </Field>
        <Field>
          <label>Dépôt capital partenaire</label>
          <Form.Item noStyle shouldUpdate>
            {() => (
              <Toggle
                checked={form.getFieldValue('partnerCapitalDeposit') === 'true'}
                onChange={v =>
                  form.setFieldValue('partnerCapitalDeposit', v ? 'true' : '')
                }
              />
            )}
          </Form.Item>
        </Field>
        <Field>
          <label>Option fiscale</label>
          <Form.Item name="taxOption" noStyle>
            <select>
              <option value="">—</option>
              <option value="LMNP">LMNP</option>
              <option value="IS">IS</option>
            </select>
          </Form.Item>
        </Field>
        <Field>
          <label>Payé par partenaire</label>
          <Form.Item noStyle shouldUpdate>
            {() => (
              <Toggle
                checked={form.getFieldValue('paidByPartner') === 'true'}
                onChange={v =>
                  form.setFieldValue('paidByPartner', v ? 'true' : '')
                }
              />
            )}
          </Form.Item>
        </Field>
        <SaveBtn loading={loading} saved={saved} />
      </Form>
    </Section>
  )
}

export default OrderParamsSection
